import { useAuth } from '../context/AuthContext';

/**
 * Custom hook that provides the current user's timezone preference
 * Falls back to 'America/Chicago' (CST/CDT) if no user preference is set
 * 
 * @returns {string} The IANA timezone identifier for the user
 */
export const useTimezone = () => {
  const { currentUser } = useAuth();
  
  // Get timezone from user profile, using CST as default
  const userTimezone = currentUser?.timezone || 'CST';
  
  // Map common abbreviations to IANA timezone identifiers
  const timezoneMap = {
    'CST': 'America/Chicago',
    'EST': 'America/New_York',
    'PST': 'America/Los_Angeles',
    'MST': 'America/Denver',
    'HST': 'Pacific/Honolulu',
    'AKST': 'America/Anchorage',
    'UTC': 'UTC'
  };
  
  // Return the IANA timezone identifier or the original value if not found in map
  return timezoneMap[userTimezone] || userTimezone;
};

export default useTimezone;